module.exports = __webpack_public_path__ + "img/title_bj.593e34d3.png";